export default "__VITE_ASSET__D5Nu3R$M__"